import { Button, useNavigate, Icon } from "components/lib";

export function ComingSoon({ t, comingSoon }) {
  const openNewTab = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    let REDIRECTION_URL = "http://localhost:8888/?session=" + user.token;
    console.log(process.env.NODE_ENV, "rocess.env.NODE_ENV");
    if (process.env.NODE_ENV == "production") {
      REDIRECTION_URL = `https://studio.mapatlas.net/?session=` + user.token;
    }
    window.open(REDIRECTION_URL, "_blank");
  };
  return (
    <div
      className={`glass-card dark:glass-card-dark rounded-2xl pt-6 pb-12 ${
        comingSoon ? "px-24 pb-32" : "px-4"
      }`}
    >
      <div className="max-w-none mx-auto">
        {comingSoon && (
          <h2 className="text-white text-[32px] md:text-[48px] lg:text-[64px] poppins-medium leading-[87px]">
            {t("comingsoon.title")} <br />
            {t("comingsoon.subtitle")},
          </h2>
        )}
        <div className="text-center">
          {comingSoon ? (
            <img
              src="/assets/coming-soon.png"
              className="mx-auto mb-12 max-w-[100px]"
            />
          ) : (
            <div className="mx-auto mb-12 w-[100px] h-[100px] flex items-center justify-center">
              <Icon name="palette" size={80} className="text-white/70" />
            </div>
          )}
          <p className="text-white/95 text-[16px] md:text-[18px] lg:text-[20px] poppins-light leading-relaxed text-center mb-12 max-w-none font-light tracking-wide">
            {t("comingsoon.description")}
          </p>
          <Button
            className="glass-button rounded-xl w-[169px] transition-all duration-300 hover:shadow-lg poppins-medium"
            onClick={openNewTab}
          >
            {t("comingsoon.button.label")}
          </Button>
        </div>
      </div>
    </div>
  );
}
